import React from 'react';

function Alert(){
    window.confirm('Redirecting..');
    window.open("https://about.netflix.com/en/company-assets");
}
function Header() {
    return (
        <div className='content3-heading' id='content3-box'>
            <h1>Looking for company assets?</h1>
            <p className='content3-details'>Get more images &amp; information on official Netflix &reg;</p>
            <div class="header-btns">
                <a href="#" target="_top">
                <button onClick={Alert} className='header-btn'>Go to About Netflix</button></a>
            </div>
        </div>
    );
}

export default Header;
